<template>
  <section>
    <v-container>
      <v-text-field label="Title" v-model="data.title"></v-text-field>
      <v-text-field
        label="Subtitle (optional)"
        v-model="data.subtitle"
      ></v-text-field>
      <draggable
        tag="v-container"
        class="row wrap justify-center align-center"
        @update="onChange"
        handle=".draggable"
        v-model="data.tiles"
      >
        <template v-for="(tile, t) in data.tiles">
          <v-col cols="6" sm="4" md="4" lg="3" xl="2" :key="`client-tile-${t}`">
            <image-picker
              v-model="tile.src"
              @deleted="removeTile(tile)"
            ></image-picker>
          </v-col>
        </template>

        <v-btn fab color="secondary" @click="addTile">
          <v-icon>fa-plus</v-icon>
        </v-btn>
      </draggable>
    </v-container>
  </section>
</template>


<script>
import sections from "@/assets/sections.json";
import draggable from "vuedraggable";
import imagePicker from "@/components/app/image-picker-2";
export default {
  name: "PageClientsEdit",
  props: ["value"],
  data() {
    return {};
  },
  components: {
    draggable,
    imagePicker,
  },
  computed: {
    data() {
      return this.value;
    },
    isDark() {
      return this.value.dark ? true : false;
    },
  },
  methods: {
    onChange() {
      this.$emit("change");
    },
    removeTile(tile) {
      this.data.tiles.splice(this.data.tiles.indexOf(tile), 1);
      this.onChange();
    },
    addTile() {
      let tile = sections.find((s) => {
        return s.type === "clients";
      });

      this.data.tiles.push({ ...tile.data.tiles[0] });
      this.onChange();
    },
  },
};
</script>

<style>
</style>